module.exports = __webpack_public_path__ + "static/15-thumb-4664e98eb46c2cead6e2582d80450641.jpg";